import { render, staticRenderFns } from "./PostCreateOverlay.vue?vue&type=template&id=7ab2fcab&"
import script from "./PostCreateOverlay.vue?vue&type=script&lang=js&"
export * from "./PostCreateOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports